class LioreWithdrawalEmailForm {
  constructor(form) {
    this.form = form;
    this.locale = form.dataset.locale === 'et' ? 'et' : 'en';
    this.recipient = form.dataset.recipient;
    this.itemsField = form.querySelector('[data-selected-items-field]');
    this.itemsInput = form.elements.items;
    this.status = form.querySelector('[data-withdrawal-email-status]');
    this.previewWrapper = form.querySelector('[data-withdrawal-email-preview-wrapper]');
    this.preview = form.querySelector('[data-withdrawal-email-preview]');

    form.addEventListener('change', (event) => {
      if (event.target.name === 'scope') this.syncScope();
    });
    form.addEventListener('submit', (event) => this.openEmail(event));
    form.querySelector('[data-copy-withdrawal-email]')?.addEventListener('click', () => this.copyEmail());
    this.syncScope();
  }

  syncScope() {
    const isPartial = this.form.elements.scope.value === 'partial';
    this.itemsField.hidden = !isPartial;
    this.itemsInput.required = isPartial;
    if (!isPartial) this.itemsInput.setCustomValidity('');
  }

  normalizedOrderNumber() {
    const value = this.form.elements.order.value.trim();
    return value.startsWith('#') ? value : `#${value}`;
  }

  buildEmail() {
    const values = {
      name: this.form.elements.name.value.trim(),
      email: this.form.elements.email.value.trim(),
      order: this.normalizedOrderNumber(),
      received: this.form.elements.received.value || (this.locale === 'et' ? 'Ei ole märgitud' : 'Not provided'),
      scope: this.form.elements.scope.value,
      items: this.form.elements.items.value.trim(),
      date: new Intl.DateTimeFormat(this.locale === 'et' ? 'et-EE' : 'en-GB', { dateStyle: 'long' }).format(new Date()),
    };

    if (this.locale === 'et') {
      return {
        subject: `Taganemisavaldus - Tellimus ${values.order}`,
        body: [
          'Käesolevaga teatan Leonem Limited OÜ-le, et taganen allpool nimetatud veebitellimuse müügilepingust.',
          '',
          `Tellimuse number: ${values.order}`,
          `Nimi: ${values.name}`,
          `Tellimuse e-post: ${values.email}`,
          `Kauba kättesaamise kuupäev: ${values.received}`,
          `Taganemise ulatus: ${values.scope === 'full' ? 'kogu tellimus' : 'valitud tooted'}`,
          ...(values.scope === 'partial' ? [`Tooted ja kogused: ${values.items}`] : []),
          `Avalduse kuupäev: ${values.date}`,
          '',
          'Palun kinnitage taganemisavalduse kättesaamine e-posti teel ja saatke tagastusjuhised.',
        ].join('\n'),
      };
    }

    return {
      subject: `Withdrawal request - Order ${values.order}`,
      body: [
        'I hereby notify Leonem Limited OÜ that I withdraw from the sales contract for the online order identified below.',
        '',
        `Order number: ${values.order}`,
        `Name: ${values.name}`,
        `Order email: ${values.email}`,
        `Date goods were received: ${values.received}`,
        `Scope of withdrawal: ${values.scope === 'full' ? 'entire order' : 'selected items'}`,
        ...(values.scope === 'partial' ? [`Products and quantities: ${values.items}`] : []),
        `Date of notice: ${values.date}`,
        '',
        'Please acknowledge receipt of this withdrawal notice by email and send the return instructions.',
      ].join('\n'),
    };
  }

  validate() {
    this.syncScope();
    if (this.form.checkValidity()) return true;
    this.form.reportValidity();
    return false;
  }

  showPreview(email) {
    this.preview.value = `${email.subject}\n\n${email.body}`;
    this.previewWrapper.hidden = false;
  }

  openEmail(event) {
    event.preventDefault();
    if (!this.validate()) return;
    const email = this.buildEmail();
    this.showPreview(email);
    this.status.textContent = this.locale === 'et'
      ? 'Avan e-posti rakenduse. Avaldus ei ole esitatud enne, kui saadate e-kirja.'
      : 'Opening your email app. Your notice is not submitted until you send the email.';
    window.location.href = `mailto:${this.recipient}?subject=${encodeURIComponent(email.subject)}&body=${encodeURIComponent(email.body)}`;
  }

  async copyEmail() {
    if (!this.validate()) return;
    const email = this.buildEmail();
    this.showPreview(email);
    const text = `${email.subject}\n\n${email.body}`;

    try {
      await navigator.clipboard.writeText(text);
      this.status.textContent = this.locale === 'et'
        ? 'E-kirja tekst on kopeeritud. Saatke see aadressil info@liore.ee.'
        : 'Email text copied. Send it to info@liore.ee.';
    } catch (_error) {
      this.preview.focus();
      this.preview.select();
      this.status.textContent = this.locale === 'et'
        ? 'Automaatne kopeerimine ei õnnestunud. Kopeerige allolev tekst ja saatke see aadressil info@liore.ee.'
        : 'Automatic copying was unavailable. Copy the text below and send it to info@liore.ee.';
    }
  }
}

document.querySelectorAll('[data-withdrawal-email-form]').forEach((form) => {
  new LioreWithdrawalEmailForm(form);
});
